import React from 'react';
import styled from 'styled-components';
import { Direction } from '~common/model/basics';
import { Icon, IconProps } from '~web/view/components/ui/icon.component';
import { changeDirection, getRotation } from '~web/view/components/ui/icon/caret.helper';

interface Props extends IconProps {
  direction?: Direction;
}
//Warning: path will lead to downward facing caret; while svg-direction-change.helper.ts was meant for right facing images.
//  therefore, will be subtracting 90 from changeDirection to make the orientation correct, as it goes right->down->left->up at 90deg intervals
export const CaretIcon: React.FunctionComponent<Props> = ({
  width = 15,
  height = 8,
  direction = Direction.Down,
  ...rest
}) => {
  const vertical = direction === Direction.Down || direction === Direction.Up;
  return (
    <StyledIcon
      width={vertical ? width : height}
      height={vertical ? height : width}
      viewBoxWidth={vertical ? 15 : 8}
      viewBoxHeight={vertical ? 8 : 15}
      transform={getRotation(changeDirection(direction) - 90)}
      {...rest}
    >
      <path d="M0 0L15 0L7.5 7.5L0 0Z" />
    </StyledIcon>
  );
};

const StyledIcon = styled(Icon)`
  user-select: none;
`;



// WEBPACK FOOTER //
// /codebuild/output/src891534606/src/modules/web/src/js/view/components/ui/icon/caret.icon.tsx